import FuelSnackbar from './fuel-snackbar';
export default FuelSnackbar;